import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { faL } from '@fortawesome/pro-solid-svg-icons';
import { faR } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import * as Product from 'types/Recipe/Detail/ErpNew/Product';
import Style from 'types/_general/Style';

interface IProps {
	product: Product.Type;
	toggleSelection: () => void;
	isInComparisonLeft: boolean;
	isInComparisonRight: boolean;
	addToComparisonLeft: () => void;
	addToComparisonRight: () => void;
}

const ProductTableItemButtons = (props: IProps) => {
	const { t } = useTranslation();
	return (
		<div className="d-flex flex-column">
			<button
				type="button"
				className={[
					'btn',
					props.product.selected ? 'btn-secondary' : 'btn-outline-secondary',
				].join(' ')}
				style={style.button}
				onClick={props.toggleSelection}
			>
				<FontAwesomeIcon icon={props.product.selected ? faMinus : faPlus} />
			</button>
			<div className="btn-group">
				<button
					type="button"
					className={[
						'btn',
						props.isInComparisonLeft ? 'btn-secondary' : 'btn-outline-secondary',
					].join(' ')}
					style={{
						...style.button,
						marginTop: '-1px',
					}}
					onClick={props.addToComparisonLeft}
					title={t('_general:COMPARISON_LEFT')}
				>
					<FontAwesomeIcon icon={faL} />
				</button>
				<button
					type="button"
					className={[
						'btn',
						props.isInComparisonRight ? 'btn-secondary' : 'btn-outline-secondary',
					].join(' ')}
					style={{
						...style.button,
						marginTop: '-1px',
					}}
					onClick={props.addToComparisonRight}
					title={t('_general:COMPARISON_RIGHT')}
				>
					<FontAwesomeIcon icon={faR} />
				</button>
			</div>
		</div>
	);
};

export default ProductTableItemButtons;

const style: Style = {
	button: {
		padding: '0',
		height: '30px',
	},
};
